<template>
  <NuxtLink
    :to="link"
    class="bg-surface-action-2 hover:bg-surface-action-hover border-1 border-border-tertiary rounded-md w-full py-20 px-16 no-underline flex flex-row gap-16 items-center focus-rounded"
    external
  >
    <NuxtImg
      :src="imgSrc"
      :alt="imgAlt ?? ''"
      class="w-48 h-48"
      width="48"
      loading="lazy"
      provider="cloudfront"
    />
    <div>
      <div
        class="heading-xxs flex flex-wrap text-text-primary"
        v-html="headerLabel"
      ></div>
      <div class="flex flex-row items-start gap-10 wrap">
        <p>{{ text }}</p>
        <NuxtImg
          :src="badgeImgSrc"
          :alt="badgeImgAlt ?? ''"
          class="w-8 h-8 mt-7 lg:mt-10"
          width="8"
          loading="lazy"
          provider="cloudfront"
        />
      </div>
    </div>
  </NuxtLink>
</template>

<script lang="ts" setup>
interface Props {
  link: string;
  imgSrc: string;
  imgAlt: string;
  headerLabel: string;
  text: string;
  badgeImgSrc: string;
  badgeImgAlt: string;
}

defineProps<Props>();
</script>
